/**
 * Stream Monitor Utility Functions
 */

import { SCORE_COLORS, RANKING_CATEGORY_STYLES, RANKING_LABELS } from './constants';

/**
 * Get CSS class for score/category color
 */
export const getScoreColor = (category) => {
  return SCORE_COLORS[category] || 'text-gray-400';
};

/**
 * Get CSS class for ranking category badge style
 */
export const getRankingCategoryStyle = (category) => {
  return RANKING_CATEGORY_STYLES[category] || 'bg-gray-100 text-gray-600';
};

/**
 * Get label with emoji for ranking category
 */
export const getRankingCategoryLabel = (category, releaseYearUnknown = false) => {
  if (category === 'NEW' && releaseYearUnknown) {
    return '🆕❓ NEW';
  }
  return RANKING_LABELS[category] || '❓';
};

/**
 * Format duration in seconds to MM:SS
 */
export const formatDuration = (seconds) => {
  if (!seconds) return '--';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
};

/**
 * Get status indicator color based on station state
 */
export const getStatusIndicatorColor = (station, realtime) => {
  if (realtime?.manual_override) {
    return station.active 
      ? 'bg-yellow-500 shadow-yellow-500/50' 
      : 'bg-yellow-500/50';
  }
  if (realtime?.is_within_schedule === false) {
    return 'bg-gray-400 dark:bg-gray-500';
  }
  return station.active 
    ? 'bg-green-500 shadow-green-500/50' 
    : 'bg-gray-400 dark:bg-gray-500';
};

/**
 * Get status indicator title/tooltip
 */
export const getStatusIndicatorTitle = (station, realtime) => {
  if (realtime?.manual_override) return 'Χειροκίνητο override';
  if (realtime?.is_within_schedule === false) return 'Εκτός χρονοπρογράμματος';
  return station.active ? 'Ενεργό' : 'Ανενεργό';
};
